const getEntityStats = ({ entity, entitiesWithStats }) => {
  if (!entitiesWithStats) return null;
  const characterMatch = entitiesWithStats.find(char => char.id === entity.id);
  if (characterMatch) {
    return characterMatch.stats;
  }
};

module.exports = getEntityStats;
